import { Injectable } from '@angular/core';
import { environment } from '@environment/environment';
import { LocalService } from './local.service';

@Injectable({
  providedIn: 'root'
})
export class VersionCheckService {

  private currentVersion = environment.appVersion;

  constructor(
    private localService: LocalService
  ) {}

  checkForVersionUpdate() {
    const savedVersion = this.localService?.getJsonValue('appVersion');
    console.log('previous version:', savedVersion);

    if (!savedVersion || savedVersion !== this.currentVersion) {
      console.log('current version:', this.currentVersion);
      this.localService.setJsonValue('appVersion', this.currentVersion);
      if (savedVersion) {
        console.log('updated version:', this.currentVersion);
        this.forceReload();
      }
    }
  }

  private forceReload() {
    window.location.href = window.location.href + '?v=' + this.currentVersion;
  }
}